import { render, staticRenderFns } from "./parcelles.vue?vue&type=template&id=c1e9d4aa"
import script from "./parcelles.js?vue&type=script&lang=js&external"
export * from "./parcelles.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports